'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var ProductThumbnail = require('@narvar/nth-block-product-thumbnail');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var ItemImage_module = require('./ItemImage.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var ProductThumbnail__default = /*#__PURE__*/_interopDefaultLegacy(ProductThumbnail);

const renderOptions = {
  escape: x => x
};
const ItemImage = ({
  item,
  featureName,
  urlTemplate,
  imageUrlTemplate
}) => {
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const url = mustache__default["default"].render(urlTemplate || '', item, undefined, renderOptions) || item.url;
  return /*#__PURE__*/React__default["default"].createElement("li", {
    className: ItemImage_module["default"].itemImageListItem
  }, /*#__PURE__*/React__default["default"].createElement(ProductThumbnail__default["default"], {
    productInfo: item,
    urlTemplate: urlTemplate,
    renderAsLink: !!urlTemplate,
    imageUrlTemplate: imageUrlTemplate,
    s: {
      width: '3.5rem',
      height: '3.5rem'
    },
    onClick: () => logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.SHIPMENTS,
      clickLinkDestinationUrl: url,
      clickLinkLabel: url,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.SHIPMENTS,
      clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_SHIPMENTS,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_SHIPMENTS,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_SHIPMENTS
    })
  }));
};

Object.defineProperty(exports, 'imageWouldRenderEmpty', {
  enumerable: true,
  get: function () { return ProductThumbnail.imageWouldRenderEmpty; }
});
exports["default"] = ItemImage;
